import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "content"];

/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { colors } from '@flowio/react-theme';
import React from 'react';
var rootStyles = /*#__PURE__*/css({
  margin: '0.626rem 0',
  padding: '0',
  fontFamily: 'inherit',
  fontSize: '24px',
  fontWeight: 300,
  lineHeight: '28px',
  color: colors.FLOW_BLUE_400
}, process.env.NODE_ENV === "production" ? "" : ";label:rootStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0NhcmRUaXRsZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBa0JtQiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9DYXJkVGl0bGUudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5cbmltcG9ydCB7IGNzcywganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgY29sb3JzIH0gZnJvbSAnQGZsb3dpby9yZWFjdC10aGVtZSc7XG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG50eXBlIE93blByb3BzID0ge1xuICBjaGlsZHJlbj86IFJlYWN0LlJlYWN0Tm9kZTtcbiAgY29udGVudD86IFJlYWN0LlJlYWN0Tm9kZTtcbn07XG5cbnR5cGUgVW5oYW5kbGVkUHJvcHMgPSBPbWl0PFxuICBSZWFjdC5IVE1MQXR0cmlidXRlczxIVE1MSGVhZGluZ0VsZW1lbnQ+LFxuICBrZXlvZiBPd25Qcm9wc1xuPjtcblxudHlwZSBQcm9wcyA9IE93blByb3BzICYgVW5oYW5kbGVkUHJvcHM7XG5cbmNvbnN0IHJvb3RTdHlsZXMgPSBjc3Moe1xuICBtYXJnaW46ICcwLjYyNnJlbSAwJyxcbiAgcGFkZGluZzogJzAnLFxuICBmb250RmFtaWx5OiAnaW5oZXJpdCcsXG4gIGZvbnRTaXplOiAnMjRweCcsXG4gIGZvbnRXZWlnaHQ6IDMwMCxcbiAgbGluZUhlaWdodDogJzI4cHgnLFxuICBjb2xvcjogY29sb3JzLkZMT1dfQkxVRV80MDAsXG59KTtcblxuY29uc3QgQ2FyZFRpdGxlOiBSZWFjdC5GQzxQcm9wcz4gPSAoe1xuICBjaGlsZHJlbixcbiAgY29udGVudCxcbiAgLi4udW5oYW5kbGVkUHJvcHNcbn0pID0+IChcbiAgPGgzIHsuLi51bmhhbmRsZWRQcm9wc30gY3NzPXtyb290U3R5bGVzfT5cbiAgICB7Y2hpbGRyZW4gIT0gbnVsbCA/IGNoaWxkcmVuIDogY29udGVudH1cbiAgPC9oMz5cbik7XG5cbkNhcmRUaXRsZS5kaXNwbGF5TmFtZSA9ICdDYXJkVGl0bGUnO1xuXG5leHBvcnQgZGVmYXVsdCBDYXJkVGl0bGU7XG4iXX0= */");

var CardTitle = function CardTitle(_ref) {
  var children = _ref.children,
      content = _ref.content,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return jsx("h3", _extends({}, unhandledProps, {
    css: rootStyles
  }), children != null ? children : content);
};

CardTitle.displayName = 'CardTitle';
export default CardTitle;